import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import { defineComponent as _defineComponent } from 'vue';
import { useSkeepers } from '~/composables/_next/useSkeepers';
import AzRating from '~/components/_next/atoms/AzRating.vue';
import { SCHEMA_AGGREGATE_RATING } from '~/constants';
import { scrollToReviews } from '~/helpers/reviewsRating';
import { useGetTranslations } from '~/composables/useGetTranslations';
import Tooltip from '~/components/Layout/ToolTip.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'AverageRatingCount',
  props: {
    reviewsTotalReviews: {
      type: Number,
      default: null
    },
    reviewsAverageRating: {
      type: Number,
      default: null
    },
    noBorder: {
      type: Boolean,
      default: false
    },
    skus: {
      type: String,
      default: ''
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var _useGetTranslations = useGetTranslations(),
      translate = _useGetTranslations.translate;
    var _useSkeepers = useSkeepers(),
      loadSkeepers = _useSkeepers.loadSkeepers,
      generateWidget = _useSkeepers.generateWidget;
    var _useNuxt2App = useNuxt2App(),
      $flag = _useNuxt2App.$flag;
    var isMainNewReviewEnabled = $flag.get('isEnabledMainNewReview');
    // initializing false for ssr
    var isSkeeperLoaded = ref(false);
    var skeepersWidget = ref(null);
    var isReviewWidgetDisplayed = ref(false);
    onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var isWidgetGenerated, observer;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return loadSkeepers();
          case 2:
            isWidgetGenerated = generateWidget();
            nextTick(function () {
              isSkeeperLoaded.value = isWidgetGenerated;
            });
            observer = new MutationObserver(function () {
              var _skeepersWidget$value;
              if ((_skeepersWidget$value = skeepersWidget.value) !== null && _skeepersWidget$value !== void 0 && _skeepersWidget$value.childElementCount) {
                isReviewWidgetDisplayed.value = true;
                observer.disconnect();
              }
            });
            if (skeepersWidget.value) {
              observer.observe(skeepersWidget.value, {
                childList: true,
                subtree: true
              });
            }
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    onBeforeUnmount(function () {
      isReviewWidgetDisplayed.value = false;
    });
    return {
      __sfc: true,
      props: props,
      translate: translate,
      loadSkeepers: loadSkeepers,
      generateWidget: generateWidget,
      $flag: $flag,
      isMainNewReviewEnabled: isMainNewReviewEnabled,
      isSkeeperLoaded: isSkeeperLoaded,
      skeepersWidget: skeepersWidget,
      isReviewWidgetDisplayed: isReviewWidgetDisplayed,
      AzRating: AzRating,
      SCHEMA_AGGREGATE_RATING: SCHEMA_AGGREGATE_RATING,
      scrollToReviews: scrollToReviews,
      Tooltip: Tooltip
    };
  }
});